export default "__VITE_ASSET__C9OQ2sMt__"